export * from './lib/base-shell.module';
